export class PaymentRoutes {
  readonly orderIdParam: string;
  readonly paymentTokenParam: string;
  readonly root: string;
  readonly failed: string;
  readonly success: string;

  constructor(basePath: string) {
    this.orderIdParam = ":orderId";
    this.paymentTokenParam = ":paymentToken";
    this.root = `${basePath}payment`;
    this.failed = "failed";
    this.success = "success";
  }

  get basePath(): string {
    return `${this.root}/${this.orderIdParam}`;
  }

  getBaseUrl(orderId: string): string {
    return `${this.root}/${orderId}`;
  }

  get failedPaymentPath(): string {
    return `${this.basePath}/${this.failed}`;
  }

  getFailedPaymentUrl(orderId: string) {
    return `${this.root}/${orderId}/${this.failed}`;
  }

  get successPaymentPath(): string {
    return `${this.basePath}/${this.paymentTokenParam}/${this.success}`;
  }

  getSuccessPaymentUrl(orderId: string, paymentToken: string): string {
    return `${this.root}/${orderId}/${paymentToken}/${this.success}`;
  }
}
